<div class="login-container">
  <div class="login-content">
    <img src="../../../assets/images/afs-logo.png" alt="Logo" class="login-logo" />
    <p class="login-textmain">Login your account.</p>
    <p class="login-textsub">Enter your Email Id below to access your account.</p>
    <form class="new-form top-margin-30">
      <div class="form-group">
        <mat-form-field style="width:100%;" appearance="outline">
          <mat-label>Enter Email: </mat-label>
          <input matInput placeholder="pat@example.com" type="email" name="username" [(ngModel)]="LoginData.username"
            required>
        </mat-form-field>
      </div>

      <button type="submit" mat-raised-button class="login-btn"
        [routerLink]="['/resetPassword',LoginData.username]">Forget Password <i
          class="fa fa-long-arrow-right left-margin-10"> </i></button>
      <div class="clearfix"></div>
    </form>
  </div>
  <div class="copyright-login"> © 2022 AFS Group. All rights reserved.</div>
</div>